import { useCallback, useMemo } from "react"

import { Pool } from "../../../api/Randoms/RandomsModel/PoolData"
import { Column } from "../../../api/Randoms/SelectPoolForRunGridColumns"
import Checkbox from "../../Checkbox"

interface SelectPoolForRunGridRowProps {
  pool: Pool
  visibleColumns: Column[]
  checked: boolean
  readonly?: boolean
  onSelectPool: (pool: Pool, checked: boolean) => void
}
function SelectPoolForRunGridRow({
  pool,
  visibleColumns,
  checked,
  readonly = false,
  onSelectPool,
}: SelectPoolForRunGridRowProps) {
  const handlePoolChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onSelectPool(pool, event.target.checked)
    },
    [pool, onSelectPool]
  )

  const renderCells = useMemo(
    () =>
      visibleColumns.map((column) => {
        const { name } = column

        switch (name) {
          case "PoolName":
            return <td key={name}>{pool.PoolName}</td>

          case "Code":
            return <td key={name}>{pool.Code}</td>

          case "SelectionInterval":
            return (
              <td key={name} className="text-center">
                {pool.SelectionInterval}
              </td>
            )

          case "LastSelection":
            return (
              <td key={name} className="text-center">
                {pool.LastSelection}
                {pool.LastSelectionStatus === 1 && <span className="small text-muted ml-1">(Canceled)</span>}
              </td>
            )

          case "DrugSampleSize":
            return (
              <td key={name} className="text-center">
                {pool.DrugSampleSize}
                {pool.DrugRateOrFixed === "Rate" && "%"}
              </td>
            )

          case "AlcoholSampleSize":
            return (
              <td key={name} className="text-center">
                {pool.AlcoholSampleSize}
                {pool.AlcoholRateOrFixed === "Rate" && "%"}
              </td>
            )

          default:
            return <td key={name}>{String(pool[name as keyof Pool] ?? "")}</td>
        }
      }),
    [visibleColumns, pool]
  )

  return (
    <tr key={pool.PoolID}>
      {!readonly && (
        <td className="text-center">
          <Checkbox id={`chb_${pool.PoolID}`} value={`${pool.PoolID}`} checked={checked} onChange={handlePoolChange} />
        </td>
      )}
      {renderCells}
    </tr>
  )
}

export default SelectPoolForRunGridRow
